let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c5hK6")).then(() => parcelRequire('bSppG'));